//#region IMPORT
import React, { useState } from 'react';
/** Services Import */
import Commons from '../../Services/Common/Common';
/** Components Import */
import M_Alarm from './M_Alarm';
import { useSave1, useSave2, useSearch1 } from './M_ALA_BASIC_Query';
import { useSave } from '../../Hooks/useSave';
import { M_ALA_BASIC_Schema } from './M_ALA_BASIC_Schema';
//#endregion

function M_AlarmFunction() {
  //#region 변수
  const [settings, setSettings] = useState([]); // 알람 세팅값 배열
  const { mutateAsync: Save1Async } = useSave1();
  const { mutateAsync: Save2Async } = useSave2();
  //#endregion

  //#region 조회
  // 알림 설정 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      if (rows.length > 0) {
        setSettings(Commons.InsertNumber(rows));
      } else {
        Save2();
      }
    },
  });

  //#endregion

  //#region 저장
  // 알림 설정 저장
  const { run: Save1 } = useSave({
    menuId: 'M_ALA_BASIC',
    schema: M_ALA_BASIC_Schema,

    requestSave: async (rows) => {
      const row = rows[0];

      await Save1Async(row);
    },
  });
  const { run: Save2 } = useSave({
    menuId: 'M_ALA_BASIC',
    schema: M_ALA_BASIC_Schema,

    requestSave: async (rows) => {
      const row = rows[0];

      await Save2Async(row);
    },
    onSuccess: () => {
      Search1();
    },
  });

  //#endregion

  //#region 나머지 함수

  // Switch 변경 핸들러
  const HandleSwitchChange = (alarmSetting, isChecked) => {
    const useYn = isChecked ? 'Y' : 'N';

    setSettings((prev) =>
      prev.map((item) =>
        item.alarmGubun === alarmSetting?.alarmGubun
          ? { ...item, useYn: useYn }
          : item
      )
    );

    // 서버 저장
    Save1([{ alarmSetting, useYn }]);
  };

  //#endregion

  return (
    <div className="wrap">
      <M_Alarm
        settings={settings}
        setSettings={setSettings}
        HandleSwitchChange={HandleSwitchChange}
      />
    </div>
  );
}

export default M_AlarmFunction;
